<template>
	<svg
		id="pinnacle_logo"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="150"
		height="37.51"
		viewBox="0 0 261.231 37.51"
	>
		<defs>
			<clipPath id="a">
				<rect width="261.231" height="37.51" fill="none"></rect>
			</clipPath>
			<clipPath id="b">
				<path d="M0,15.131H261.231v-37.51H0Z" transform="translate(0 22.379)" fill="#f5f5f5"></path>
			</clipPath>
		</defs>
		<g clip-path="url(#a)">
			<g clip-path="url(#b)">
				<g transform="translate(0 0.899)">
					<path
						d="M0,0H19.258c5.5,0,10.752,2.752,10.752,10.3,0,6.751-4.452,10.4-12.4,10.4H3.7v15H0ZM3.7,
						17.307H18c6.2,0,8-2.853,8-7,0-5.353-3-6.9-7.251-6.9H3.7Z"
						fill="#f5f5f5"
					></path>
				</g>
			</g>
			<path d="M20.884,13.87h3.7V-21.843h-3.7Z" transform="translate(14.12 22.741)" fill="#f5f5f5"></path>
			<g transform="translate(45.702 0.898)">
				<path
					d="M11.9,0V30.51h-.1L-13.152,0h-4.455V35.713h3.7V5.2h.1L11.3,35.713h4.3V0Z"
					transform="translate(17.607)"
					fill="#f5f5f5"
				></path>
			</g>
			<g transform="translate(85.507 0.898)">
				<path
					d="M11.9,0V30.51h-.1L-13.153,0h-4.453V35.713h3.7V5.2h.1l25.1,30.51h4.3V0Z"
					transform="translate(17.606)"
					fill="#f5f5f5"
				></path>
			</g>
			<g transform="translate(121.713 0.898)">
				<path
					d="M6.536,0l-16.2,35.713h4L-.814,24.86H17.992l4.752,10.853h4.3L10.838,0Zm2.1,3.7L16.49,21.459H.686Z"
					transform="translate(9.667)"
					fill="#f5f5f5"
				></path>
			</g>
			<g clip-path="url(#b)">
				<g transform="translate(160.163 0)">
					<path
						d="M14.79,9.28c-.8,8-7.4,14.5-17.658,14.5-11.6,0-19.007-7.3-19.007-18.754,0-8.153,5.055-18.756,
						19.007-18.756,7.8,0,16.257,3.552,17.354,12.955h-3.7c-1.1-6.8-7.2-9.554-13.654-9.554-8.853,0-15,
						4.951-15,15.355,0,7.953,4.153,15.355,15,15.355,8.5,0,12.707-4.3,13.957-11.1Z"
						transform="translate(21.875 13.726)"
						fill="#f5f5f5"
					></path>
				</g>
			</g>
			<g transform="translate(202.17 0.898)">
				<path d="M0,0V35.713H26.355v-3.4H3.7V0Z" fill="#f5f5f5"></path>
			</g>
			<g transform="translate(232.423 0.898)">
				<path d="M0,0V35.713H28.807v-3.4H3.7V18.906H27.508v-3.4H3.7V3.4H28.408V0Z" fill="#f5f5f5"></path>
			</g>
		</g>
	</svg>
</template>
